import basketItemSlice from './basketItemSlice';

export default basketItemSlice;
